export const theme = {
  color: {
    dimmedBackground: "#000000a3",
    cardEditorGray: "#0009",
    cardEditorText: "#c7d1db",
    backgroundGray: "#F3F5F7",
    cardListGray: "#EAECF0",
    skeletonGray: "rgba(0, 0, 0, 0.11)",
    hoverPointGray: "#E1E4E9",
    textPointGray: "#5E6C83",
    textDefaultGray: "#3C3E3F",
    modalBackgroundGray: "#F4F5F7",
    siderBackground: "#E2E8ED",
    buttonBackground: "rgba(0, 0, 0, 0.1)",
    white: "white",
    black: "black",
    headerBackground: "#F3F6F8",
    border: "#D0D6DD",
    buttonBlue: "#0079BF",
  },
  borderRadius: {
    button: "6px",
    card: "12px",
  },
  boxShadow: {
    card: "0 1px 0 #091e4240",
  },
};
